import React, { useCallback, useEffect, useState } from 'react';
import { Link, Route, Switch, useParams } from 'react-router-dom';
import { Card } from 'reactstrap';

import Content from 'src/layout/content/Content';

import Information from './views/information';
import { Block, Icon } from "src/components/Component";
import { Auth } from "aws-amplify";
import Axios from "axios";
import API_ROUTES from "src/config/api";
import { useSelector } from "react-redux";
import HasRole from "src/utils/has-role";
import HasFeature from "src/utils/has-feature";
import Settlement from "./views/settlement";
import Payout from "./views/payout";
import Bank from './views/bank';

import { convertPenniesToDecimals } from 'src/utils/money';
import Skeleton from 'react-loading-skeleton';

import TransactionStatusTransformer from 'src/transformer/transaction-status';

const ALLOWED_STATUSES = ['COMPLETE', 'PARTIALLYREFUNDED'];

const Payment = () => {
  const { id } = useParams();
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);
  const [reloadCount, setReloadCount] = useState(0);

  const { organisation, enums } = useSelector((state) => state);
  const { account } = useSelector((state) => state.account);

  const triggerReload = () => setReloadCount(reloadCount + 1);

  const getPayment = useCallback(async () => {
    setLoading(true);

    const user = await Auth.currentAuthenticatedUser();

    const result = await Axios(
      API_ROUTES.agent["payment:get"](id),
      {
        method: 'get',
        headers: { Authorization: `Bearer ${user.signInUserSession.idToken.jwtToken}` },
      }
    );

    setData(result.data.data);
    setLoading(false);
  }, [organisation.organisation]);

  useEffect(() => {
    getPayment();
  }, [organisation.organisation, reloadCount]);

  
  let status = null;
  if (data?.status?.id) {
    status = TransactionStatusTransformer(data.status.id);
  }

  return (
    <React.Fragment>
      <Content>

        <Block>
          <Card className="card-bordered rounded-md -mx-8 -mt-10">

            {loading && (
              <div className=' px-12 pt-8 pb-4'>
                <Skeleton count={1} height="50px" className="mb-2" />
              </div>
            )}

            {!loading && (
              <div className=' px-12 pt-10 pb-6'>
                <h2 className='text-violet-800 text-3xl font-thin block float-left'><strong className='font-bold'>{new Intl.NumberFormat('en-GB', { minimumFractionDigits: 2 }).format(convertPenniesToDecimals(data.amount))}</strong> {enums.enums.currency[data.currency].major_unit} from <strong className='font-bold'>{data?.metadata?.cardholder_name ? data.metadata.cardholder_name.toUpperCase() : data?.customer?.customer_name.trim()}</strong></h2>
                <div className={`float-left block ${ status.color } text-white text-xs mt-1.5 px-2 py-0.5 rounded-lg ml-4`}>
                  { status.label }
                  { status.newIcon } 
                </div>
              </div>
            )}

            <ul className="nav nav-tabs nav-tabs-mb-icon nav-tabs-card px-12">
              <li
                className={`nav-item ${window.location.pathname === `/payment/${id}`
                  ? "active current-page"
                  : ""
                  } `}
              >
                <Link
                  to={`/payment/${id}`}
                  className={`nav-link
                    ${window.location.pathname === `/payment/${id}` ? "active" : ""}
                  `}
                >
                  <Icon name="info-i" />
                  <span>Payment Information</span>
                </Link>
              </li>

              {ALLOWED_STATUSES.includes(data?.status?.id) && (
                <li
                  className={`nav-item ${window.location.pathname === `/payment/${id}/settlement`
                    ? "active current-page"
                    : ""
                    } `}
                >
                  <Link
                    to={`/payment/${id}/settlement`}
                    className={`nav-link
                    ${window.location.pathname === `/payment/${id}/settlement` ? "active" : ""}
                  `}
                  >
                    <Icon name="money" />
                    <span>Acquirer Reconciliation</span>
                  </Link>
                </li>
              )}

              {HasRole(account, ['payouts:view']) && HasFeature(organisation.features, ['payouts']) && ALLOWED_STATUSES.includes(data?.status?.id) && (
                <li
                  className={`nav-item ${window.location.pathname === `/payment/${id}/payout`
                    ? "active current-page"
                    : ""
                    } `}
                >
                  <Link
                    to={`/payment/${id}/payout`}
                    className={`nav-link
                    ${window.location.pathname === `/payment/${id}/payout` ? "active" : ""}
                  `}
                  >
                    <Icon name="wallet-out" />
                    <span>Disbursal Detail</span>
                  </Link>
                </li>
              )}

              {ALLOWED_STATUSES.includes(data?.status?.id) && (
                <li
                  className={`nav-item ${window.location.pathname === `/payment/${id}/bank`
                    ? "active current-page"
                    : ""
                    } `}
                >
                  <Link
                    to={`/payment/${id}/bank`}
                    className={`nav-link
                    ${window.location.pathname === `/payment/${id}/bank` ? "active" : ""}
                  `}
                  >
                    <Icon name="wallet" />
                    <span>Bank Reconciliation</span>
                  </Link>
                </li>
              )}

            </ul>

            <div className="card-inner card-inner-lg pt-4 px-12">
              <Switch>
                <Route
                  exact
                  path={`/payment/:id/`}
                  render={() => <Information data={data} loading={loading} triggerReload={triggerReload} />}
                />
                <Route
                  exact
                  path={`/payment/:id/settlement`}
                  render={() => <Settlement data={data} loading={loading} triggerReload={triggerReload} />}
                />
                <Route
                  exact
                  path={`/payment/:id/payout`}
                  render={() => <Payout data={data} loading={loading} triggerReload={triggerReload} />}
                />
                <Route
                  exact
                  path={`/payment/:id/bank`}
                  render={() => <Bank data={data} loading={loading} triggerReload={triggerReload} />}
                />
              </Switch>
            </div>
          </Card>
        </Block>
      </Content>
    </React.Fragment>
  );
};

export default Payment;
